import { render, staticRenderFns } from "./CompanyProfileAgencies.vue?vue&type=template&id=5d701e74"
import script from "./CompanyProfileAgencies.vue?vue&type=script&lang=js"
export * from "./CompanyProfileAgencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports